// export this package's api
import Upload from './Upload';

export default Upload;


//////////////////
// WEBPACK FOOTER
// ./node_modules/.2.4.4@rc-upload/es/index.js
// module id = 380
// module chunks = 1